
import {BookOpen, ChevronLeft, Clock, Star, Users} from "lucide-react";
import React from "react";
import {convertToJalaliWithFormat} from "@/lib/utils/date";
import RenderIf from "@/components/render-if";
import {HomeworkStatusEnum} from "@/lib/helper/enumType";
import {Link} from "react-router-dom";
import {Button} from "antd";
import {sprintf} from "@/lib/utils/sprintf";
import {URLS} from "@/lib/urls";

export default function TeacherHomeworkCard({homework, onClick}) {
    const pct = homework?.takenunits_count > 0 ? (homework?.reports_count / homework?.takenunits_count) * 100 : 0;

    return (
        <div
            onClick={() => {
            }}
            className="rounded-2xl border border-slate-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-sm p-5 cursor-pointer hover:shadow-md hover:border-blue-200 dark:hover:border-blue-700 transition-all card-hover"
        >
            <div className="flex items-start justify-between mb-3">
                <div className="w-10 h-10 rounded-xl bg-blue-50 dark:bg-blue-950/50 flex items-center justify-center">
                    <BookOpen className="w-5 h-5 text-blue-600 dark:text-blue-400"/>
                </div>
                <span
                    className={`text-xs px-2.5 py-1 rounded-full border border-gray-200 dark:border-gray-700 font-medium ${HomeworkStatusEnum(homework?.status, 'color')}`}>
                    {HomeworkStatusEnum(homework?.status)}
                </span>
            </div>

            <h3 className="font-bold text-slate-800 dark:text-gray-100 mb-1">{homework?.title}</h3>
            <p className="text-xs text-slate-500 dark:text-gray-400 mb-4 line-clamp-2">{homework?.description}</p>

            <RenderIf condition={homework?.file}>
                <p className="text-xs text-slate-500 dark:text-gray-400 mb-4 line-clamp-2">
                    دارای فایل راهنما
                    <Button size={'small'} className={'mx-2'} variant={'link'} color={'primary'}>
                        <Link to={homework?.file} target={'_blank'}>نمایش فایل</Link>
                    </Button>
                </p>
            </RenderIf>

            <div className="flex items-center gap-3 text-xs text-slate-500 dark:text-gray-400 mb-4">
                <RenderIf condition={homework?.date}>
                    <span className="flex items-center gap-1">
                        <Clock className="w-3.5 h-3.5"/>
                        مهلت انجام: {convertToJalaliWithFormat(homework?.date)}
                    </span>
                </RenderIf>
                <RenderIf condition={homework?.score}>
                    <span className="flex items-center gap-1">
                        <Star className="w-3.5 h-3.5"/>
                        {homework?.score} نمره
                    </span>
                </RenderIf>
            </div>

            {homework?.status !== 'draft' && (
                <div>
                    <div className="flex justify-between text-xs mb-1.5">
                        <span className="text-slate-500 dark:text-gray-400 flex items-center gap-1">
                            <Users className="w-3 h-3"/>
                            تحویل داده
                        </span>
                        <span className="font-semibold text-slate-700 dark:text-gray-200">
                            {homework?.reports_count} از {homework?.takenunits_count}
                        </span>
                    </div>
                    <div className="h-1.5 bg-slate-100 dark:bg-gray-800 rounded-full overflow-hidden">
                        <div
                            className="h-full bg-gradient-to-l from-blue-500 to-blue-400 rounded-full transition-all duration-500"
                            style={{width: `${pct}%`}}
                        />
                    </div>
                </div>
            )}

            <div className="mt-4 pt-3 border-t border-slate-100 dark:border-gray-800 flex items-center justify-between flex-wrap gap-4">
                <span className="text-xs text-slate-400 dark:text-gray-500">
                    تاریخ ایجاد: {convertToJalaliWithFormat(homework?.created_at)}
                </span>

                <Link to={sprintf(URLS.teacher.lessons.homeworksUpdate, {
                    id: homework?.lesson_id,
                    homeworkId: homework?.id
                })}>
                    <span className="text-xs text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-200 font-medium flex items-center gap-1 transition-colors">
                        ویرایش تکلیف
                        <ChevronLeft className="w-3.5 h-3.5"/>
                    </span>
                </Link>

                <Link to={URLS.teacher.homeworks.dashboard + '?homework_id=' + homework?.id}>
                    <span className="text-xs text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-200 font-medium flex items-center gap-1 transition-colors">
                        مشاهده پاسخ‌های ارسال شده
                        <ChevronLeft className="w-3.5 h-3.5"/>
                    </span>
                </Link>
            </div>
        </div>
    );
}
